import React from 'react';
import { Box, Button, SxProps } from '@mui/material';
import { useDispatch } from 'react-redux';
import { createAnalytics } from '../../../../store/AnalyticsSlice';
import { useAppSelector } from '../../../../hooks';
import { getAuthState } from '../../../../store/AuthSlice';

const boxProps: SxProps = {
  position: 'fixed',
  bottom: { xs: '25%', sm: '15%' },
  left: { xs: '2%', sm: '25%' },
  right: { xs: '2%', sm: '25%' },
  color: 'white',
  flexDirection: { xs: 'column', sm: 'row' },
  backgroundColor: '#1E293B',
  padding: '15px 30px',
  zIndex: 1000,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: '10px',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: 'inherit',
    padding: '3px',
    background: 'linear-gradient(90deg, #DB86F8 0%, #006FD6 100%)',
    WebkitMask:
      'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    maskComposite: 'exclude',
    zIndex: -1,
  },
};

interface IBannerProps {
  open: boolean;
  onClose: () => void;
}

const AiHintPreferenceBanner: React.FC<IBannerProps> = ({ open, onClose }) => {
  const authState = useAppSelector(getAuthState);
  const authUser = authState.user;
  const dispatch = useDispatch();

  const handleButtonClick = (response: string) => {
    dispatch(
      createAnalytics({
        type: 'LP - AI tutor hint preference',
        data: {
          userResponse: response,
          userEmail: authUser?.email,
          userFirstName: authUser?.firstname,
          userLastName: authUser?.lastname,
          userRole: authUser?.role.name,
        },
        userId: authUser?._id,
      })
    );
    onClose();
  };

  return (
    <Box sx={boxProps}>
      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0, sm: 2 } }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/backgrounds/star.png`}
          alt="ai-logo"
          style={{ width: '28px', height: '26px', marginRight: '10px' }}
        />
        <span>Would you like AI to assist you with a hint?</span>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
        <Button
          onClick={() => handleButtonClick('Yes')}
          sx={{
            color: 'white',
            textTransform: 'none',
            padding: '0',
            minWidth: 'auto',
          }}
        >
          Yes
        </Button>
        <span style={{ margin: '0 15px' }}>|</span>
        <Button
          onClick={() => handleButtonClick('No')}
          sx={{
            color: 'white',
            textTransform: 'none',
            padding: '0',
            minWidth: 'auto',
          }}
        >
          No
        </Button>
      </Box>
    </Box>
  );
};

export default AiHintPreferenceBanner;
